import React, { useContext } from 'react';

export const ApplicationContext = React.createContext<Partial<Models.Application>>(null);

export interface ApplicationContextProviderProps {
	application: Models.Application;
	children?: React.ReactNode;
}

export const ApplicationContextProvider = ({ application, children }: ApplicationContextProviderProps) => {
	return <ApplicationContext.Provider value={application}>{children}</ApplicationContext.Provider>;
};

export function useApplicationContext(): Partial<Models.Application> {
	return useContext(ApplicationContext);
}
